import { Injectable } from '@angular/core';
import { Subject, Subscription } from 'rxjs';

export class TransportableMessage {
  private eventSource = new Subject<unknown>();

  get observable() {
    return this.eventSource.asObservable();
  }

  emit(eventData) {
    this.eventSource.next(eventData);
  }

  subscribe(observer?: (any) => void): Subscription {
    return this.observable.subscribe(observer);
  }
}

@Injectable()
export class MessageTransportService {
  private events: {
    [id: string]: TransportableMessage;
  } = {};

  // retrieve or lazily instantiate event by name
  event(id: string): TransportableMessage {
    if (this.events[id]) {
      return this.events[id];
    } else {
      this.events[id] = new TransportableMessage();
      return this.events[id];
    }
  }
}
